const PREVIEW_FIELDS = ['title', 'premise', 'stakes', 'conflict', 'hook'] as const;

const STREAM_PREVIEW_FALLBACK = '正在梳理故事的开场、人物关系和核心矛盾……';

const readPartialJsonString = (source: string, key: string): string => {
  const field = new RegExp(`"${key}"\\s*:\\s*"`).exec(source);
  if (!field) return '';

  let cursor = field.index + field[0].length;
  let value = '';
  while (cursor < source.length) {
    const character = source[cursor];
    if (character === '"') break;
    if (character !== '\\') {
      value += character;
      cursor += 1;
      continue;
    }

    const escaped = source[cursor + 1];
    if (!escaped) break;
    if (escaped === 'u') {
      const code = source.slice(cursor + 2, cursor + 6);
      if (!/^[0-9a-fA-F]{4}$/.test(code)) break;
      value += String.fromCharCode(Number.parseInt(code, 16));
      cursor += 6;
      continue;
    }
    const escapedCharacters: Record<string, string> = {
      '"': '"',
      '\\': '\\',
      '/': '/',
      b: '\b',
      f: '\f',
      n: '\n',
      r: '\r',
      t: '\t',
    };
    value += escapedCharacters[escaped] ?? escaped;
    cursor += 2;
  }
  return value;
};

/**
 * AI 接口需要流式输出 JSON 才能稳定落库，但生成中的用户预览只展示自然语言内容。
 * 这里兼容尚未闭合的 JSON 字符串，避免流式过程中短暂露出字段名和结构符号。
 */
export const humanizeInspirationStream = (rawContent: string): string => {
  const paragraphs = PREVIEW_FIELDS
    .map((field) => readPartialJsonString(rawContent, field))
    .map((value) => value.replace(/\r\n?/g, '\n').replace(/\n{3,}/g, '\n\n').trim())
    .filter((value, index, values) => Boolean(value) && values.indexOf(value) === index);

  return paragraphs.join('\n\n') || STREAM_PREVIEW_FALLBACK;
};
